var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBugReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 16.154C18.5226 16.6668 17.3147 17.9602 16.3191 19L12.1526 14.3897L14.6472 11.8071L19 16.154ZM11.258 13.4639L13.7526 10.8813C13.7526 10.8813 12.4857 9.88041 12.6024 9.25529C12.7191 8.63018 12.9826 7.74624 14.8175 6.962C16.6522 6.17809 18.3639 6.10729 18.3639 6.10729L18.4254 5.25096C18.4254 5.25096 14.2084 4.59142 11.9807 5.41073C9.75302 6.23004 7.23331 9.3144 7.23331 9.3144C7.23331 9.3144 7.67276 10.8059 6.91995 11.5856C6.16683 12.3653 5.15462 11.4664 5.15462 11.4664L4 12.9842L6.91368 16.0004L8.37695 14.8025C8.37695 14.8025 7.68436 13.7285 8.36879 13.0856C9.84147 11.7019 11.258 13.4639 11.258 13.4639Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugReport);
export default __webpack_public_path__ + "static/media/BugReport.983a2923.svg";
export { ForwardRef as ReactComponent };